import { render, staticRenderFns } from "./WarningPopup.vue?vue&type=template&id=49e66a4a&scoped=true&"
import script from "./WarningPopup.vue?vue&type=script&lang=js&"
export * from "./WarningPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e66a4a",
  null
  
)

export default component.exports